import * as React from "react";
import "./GenericInputHeader.css";
import { StatusComponent } from "../widgets/StatusComponent";
import { Loading } from "../../Loading";


interface GenericInputHeaderProps {
    status: null | boolean | Loading;
    questionText: string;
}

export class GenericInputHeader extends React.Component<GenericInputHeaderProps> {
    constructor(props: GenericInputHeaderProps) {
        super(props);
    }

    render() {
        return (
            <span className="control-group">
                <div className="GenericInputHeader__container">
                    <div dangerouslySetInnerHTML={{ __html: this.props.questionText }} />
                    <StatusComponent questionStatus={this.props.status}/>
                </div>
            </span>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericInputHeader.tsx